(function () {
  function init() {
    var vids = document.querySelectorAll('video.tt-video__el[data-src]');
    if (!vids.length) return;
    function load(v) { if (!v.src) { v.src = v.dataset.src; v.load(); } }
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { load(v); v.play().catch(function(){}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { load(v); var p = v.play(); if (p) p.catch(function(){}); }
        else if (!v.paused) { v.pause(); }
      });
    }, { rootMargin: '200px 0px', threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
